var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdobeIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 22,
  fill: "none",
  viewBox: "0 0 24 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EB1000",
  d: "m14.235 21.62-1.742-4.85H8.116l3.677-9.258 5.58 14.109H24L15.155.379H8.909L0 21.621z"
})));
export { SvgAdobeIcon as ReactComponent };
export default __webpack_public_path__ + "d8139e30df4fdb8dc4aaef05324876de.svg";